var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": "linkedin"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "linkedin",
    lang: "en"
  }, "Linkedin icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19922 17.7997H0.199219V5.79971H4.19922V17.7997ZM2.20002 4.19971C1.09362 4.19971 0.199219 3.30291 0.199219 2.19891C0.199219 1.09491 1.09522 0.199707 2.20002 0.199707C3.30242 0.199707 4.19922 1.09651 4.19922 2.19891C4.19922 3.30291 3.30242 4.19971 2.20002 4.19971ZM18.5992 17.7997H14.7536V11.9597C14.7536 10.5669 14.7272 8.77571 12.7544 8.77571C10.752 8.77571 10.444 10.2925 10.444 11.8589V17.7997H6.59922V5.79091H10.2904V7.43171H10.3424C10.856 6.48771 12.1112 5.49251 13.9832 5.49251C17.8792 5.49251 18.5992 7.97971 18.5992 11.2133V17.7997Z",
    fill: "#000000"
  })));
}
export default SvgLinkedininline;